var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25894 17.5936C3.14076 15.7086 2.74916 13.4802 3.15768 11.3269C3.56621 9.17362 4.74675 7.24352 6.47764 5.89905C8.20853 4.55458 10.3707 3.88823 12.5581 4.02511C14.7455 4.16199 16.8078 5.0927 18.3575 6.64247C19.9073 8.19223 20.838 10.2544 20.9749 12.4419C21.1118 14.6293 20.4455 16.7915 19.101 18.5223C17.7565 20.2532 15.8264 21.4338 13.6731 21.8423C11.5199 22.2509 9.29149 21.8593 7.40648 20.7411L7.40651 20.741L4.29808 21.6291C4.16947 21.6659 4.03338 21.6676 3.90391 21.634C3.77443 21.6005 3.65628 21.5329 3.56171 21.4383C3.46713 21.3437 3.39957 21.2256 3.36602 21.0961C3.33247 20.9666 3.33415 20.8305 3.37089 20.7019L4.25902 17.5935L4.25894 17.5936Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5073 21.9866C11.9498 23.2426 12.6652 24.3848 13.6022 25.3311C14.5392 26.2773 15.6744 27.0039 16.926 27.4587C18.1776 27.9134 19.5144 28.0849 20.8403 27.9608C22.1662 27.8368 23.448 27.4202 24.5935 26.7411L24.5935 26.741L27.7019 27.6291C27.8305 27.6659 27.9666 27.6676 28.0961 27.634C28.2255 27.6005 28.3437 27.5329 28.4383 27.4383C28.5328 27.3438 28.6004 27.2256 28.6339 27.0961C28.6675 26.9667 28.6658 26.8306 28.6291 26.702L27.7409 23.5935L27.741 23.5936C28.5301 22.2628 28.9629 20.751 28.9977 19.2043C29.0324 17.6575 28.6679 16.1278 27.9394 14.7629C27.2108 13.398 26.1428 12.2439 24.8383 11.4119C23.5339 10.58 22.037 10.0983 20.4922 10.0132",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsCircle);
export default __webpack_public_path__ + "static/media/ChatsCircle.0ab68af9f5aff80cc007c4757f69f887.svg";
export { ForwardRef as ReactComponent };